import { css } from 'glamor'

const animationTime = '.7s'

export default {
  dynamic: css({
    marginLeft: '5px',
    fontSize: '12px',
    fontFamily: "'Press Start 2P', cursive",
    transition: `opacity ${animationTime}, color ${animationTime}, font-weight ${animationTime}, scale ${animationTime}`,
    opacity: 0,

    '@media(min-width: 530px)': {
      fontSize: '16px',
    },
  }),
  plusAnimation: css({
    color: '#00c100',
    fontWeight: '900',
    // transform: 'scale(2)',
    opacity: 1,
  }),
  minusAnimation: css({
    color: '#ff0000',
    fontWeight: '900',
    // transform: 'scale(2)',
    opacity: 1,
  }),
  neitralAnimation: css({
    color: '#ccc',
    fontWeight: '900',
    // transform: 'scale(2)',
    opacity: 1,
  }),
}



// WEBPACK FOOTER //
// ./src/components/Score/components/Dynamic/styles.js